import { selectBuildingConstructionInProgress } from "../../../selectors/selectBuildingConstructionInProgress";
import { utilBuildings } from "../../../utils/utilBuildings";
export var checkAnyAcreConstructionInProgressAvailable = function (path) { return function (action, state$, dependencies) {
    var state = state$.value;
    var buildingInConstruction = selectBuildingConstructionInProgress(state);
    if (buildingInConstruction && utilBuildings.isAcre(buildingInConstruction)) {
        return path;
    }
    else {
        return undefined;
    }
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/checks/checkAnyAcreConstructionInProgressAvailable.ts
// module id = 2390
// module chunks = 3